<template>
    <div class="ui-feed">
        <div class="ui-feed-header" v-if="hasHeader">
            <slot name="header"></slot>
        </div>
        <div class="ui-feed-content scroll-color" v-if="hasDefaultSlot">
            <div class="list">
                <slot />
            </div>
        </div>
		<div class="ui-feed-no-content" v-else>
			<div class="caption">
				<i class="fal fa-list-alt" />
				<div class="title">Nenhum item foi encontrado.</div>
			</div>
		</div>
        <div class="ui-feed-footer" v-if="hasFooter">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            hasHeader: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {}
        },

        computed: {
            hasDefaultSlot() {
                return this.$slots.default ? true : false
            },

            // hasHeader() {
            //     return this.$slots.header ? true : false
            // },

            hasFooter() {
                return this.$slots.footer ? true : false
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
